import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_OWNERSHIP_API } from "../apiRoutes";

interface UseGetPropertyOwnerByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyOwnerById = async (id: string) =>
  await axiosAuth.get(`${PROPERTY_OWNERSHIP_API}/${id}`);

const useGetPropertyOwnerById = ({
  id,
  queryParams,
}: UseGetPropertyOwnerByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["propertyOwner", id],
    queryFn: () => getPropertyOwnerById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyOwnerById;
